import { render, staticRenderFns } from "./SuperTableDetails.vue?vue&type=template&id=569666fc"
import script from "./SuperTableDetails.vue?vue&type=script&lang=js"
export * from "./SuperTableDetails.vue?vue&type=script&lang=js"
import style0 from "./SuperTableDetails.vue?vue&type=style&index=0&id=569666fc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports